import { AppThunk } from '../root.reducer'
import { ApiConstants, ApiNameFromConst } from './constants'

/** @deprecated If using Redux then replace with RTK Query; if using React then replace with Axios, hooks, and context as needed */
export type ApiAction<ApiConst, ApiReturnType> =
  | { type: ApiConstants<ApiNameFromConst<ApiConst>>['REQUESTED'] }
  | { type: ApiConstants<ApiNameFromConst<ApiConst>>['SUCCESS'], response: ApiReturnType }
  | { type: ApiConstants<ApiNameFromConst<ApiConst>>['FAILURE'], error: unknown }

/**
 * @deprecated If using Redux then replace with RTK Query; if using React then replace with Axios, hooks, and context as needed
 * @param actionConsts
 * @param api function which calls the API
 * @param apiParameters array to pass to the api(apiParameters) function
 * @returns First function returns an action creator function which returns a dispatch function when fed parameters
 */
export const createApiAction = <ApiName extends string>(actionConsts: ApiConstants<ApiName>, api: $TSFIXME) => (apiParameters: $TSFIXME = []): AppThunk => async dispatch => {
  dispatch({ type: actionConsts.REQUESTED })
  try {
    const response = await api(...(Array.isArray(apiParameters) ? apiParameters : [apiParameters]))
    dispatch({
      response,
      type: actionConsts.SUCCESS,
    } satisfies ApiAction<ApiConstants<ApiName>, typeof api>)
    return response
  } catch (error) {
    dispatch({
      error,
      type: actionConsts.FAILURE,
    } satisfies ApiAction<ApiConstants<ApiName>, typeof api>)

    throw error
  }
}
